module.exports = __webpack_public_path__ + "img/en-id.9b87c0e2.png";